import React from "react";
import { Navigate } from "react-router-dom";
import { useUiPack } from "@/hooks/useUiPack";
import SimpleOperationsHub from "@/pages/simple/SimpleOperationsHub";

/** Classic keeps Operations in the top menu; Simple gets a dedicated touch hub. */
export default function UiPackOperationsHub() {
  const { isSimple } = useUiPack();
  if (!isSimple) return <Navigate to="/pos" replace />;
  return <SimpleOperationsHub />;
}
